module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/SugarRay-ab57d7e8cd957a6a4c17dd4a67387191.jpg";